export default __webpack_public_path__ + "static/media/d.4b2ad261.png";